const subdomain =
  process.env.REACT_APP_INPUT_STAGE === 'staging' ? 'staging' : `testing-${process.env.REACT_APP_INPUT_ENV}`;
const domain = `api.${subdomain}.econsult.awshealth.net`;
const ROOT_URL = `https://${domain}`;

export const dteConfig = {
  ROOT_URL,
  SUMMARISER: {
    BASE_URL: `https://summariser.${subdomain}.econsult.awshealth.net`,
    HOST: `${ROOT_URL}/summariser`,
    WEBSOCKET: `wss://${domain}/summariser`,
  },
  AUTH: {
    HOST: `${ROOT_URL}/auth`,
  },
  USER_MANAGEMENT: {
    HOST: `${ROOT_URL}/usermanagement`,
  },
  CUSTOMISATION: {
    HOST: `${ROOT_URL}/customisation`,
  },
  SMART_INBOX: {
    HOST: `${ROOT_URL}/workflow/home`,
  },
  E_LITE: {
    HOST: `https://elite.${subdomain}.econsult.awshealth.net`,
  },
  SETTINGS: {
    HOST: `https://settings.${subdomain}.econsult.awshealth.net`,
  },
  REPORTING: {
    HOST: `${ROOT_URL}/workflow/reports`,
  },
  FRESHPAINT: {
    ENABLED: true,
    ID: '8cbe151d-4bfa-47a8-8a9e-e1aaf24bbfdc',
  },
  STRIPE: {
    // this key is only for dte-t we need to add logic for other dtes.
    PUBLISHABLE_KEY:
      process.env.REACT_APP_INPUT_ENV?.toLowerCase() === 'a'
        ? 'pk_test_51RxnL4FUtEHg0n2MaGZw7A81CQ28ehhGa32c15F9Lr7sXlBOn3PBbERDvsx5BBvbwp8fb0TmPXd8rLd7aEoBruVc00qu9I2RWo'
        : 'pk_test_51RvySGFLAlLCne07u8qMNdllmh3BHnaGbEosvRuAuX0kDTJ1LL9l7R6fIYPGe8NSAgBykk0pF3IIPvkZ8YU6gqDv009j7dodRL',
  },
};
